import { createContext, useContext, useState, useEffect } from 'react';
import { api } from './AuthContext';
import { useAuth } from './AuthContext';

const ProjectContext = createContext(null);

const STORAGE_KEY = 'gds_selected_project';

export const ProjectProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectIdState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ''
  );

  useEffect(() => {
    if (!isAuthenticated) return;
    api.get('/projects')
      .then(r => {
        const list = r.data || [];
        setProjects(list);
        if (list.length) {
          const ids = list.map(p => String(p.project_id));
          const stored = localStorage.getItem(STORAGE_KEY);
          if (!stored || !ids.includes(stored)) {
            const first = String(list[0].project_id);
            setSelectedProjectIdState(first);
            localStorage.setItem(STORAGE_KEY, first);
          }
        }
      })
      .catch(() => {});
  }, [isAuthenticated]);

  const setSelectedProjectId = (id) => {
    const strId = String(id);
    setSelectedProjectIdState(strId);
    localStorage.setItem(STORAGE_KEY, strId);
  };

  const selectedProject = projects.find(p => String(p.project_id) === selectedProjectId) || null;

  return (
    <ProjectContext.Provider value={{ projects, selectedProjectId, selectedProject, setSelectedProjectId }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};
